import responseStatusActions from '../actions/ResponseStatusActions';

function setLastSaved(state, contentRevisionId, dateStamp) {
    const current = state[contentRevisionId];

    if (!current || current.lastSavedAt < dateStamp) {
        return {
            ...state,
            [contentRevisionId]: { ...current, lastSavedAt: dateStamp },
        };
    }

    return state;
}

function setRepliedTo(state, contentRevisionId, repliedTo, allDeclarationsRepliedTo) {
    return {
        ...state,
        [contentRevisionId]: { ...state[contentRevisionId], repliedTo, allDeclarationsRepliedTo },
    };
}
function setAutoSaveFailedResponse(state, contentRevisionId, autoSaveResponse) {
    return {
        ...state,
        autoSaveResponses: {
            ...state.autoSaveResponses,
            [contentRevisionId]: { success: autoSaveResponse },
        },
    };
}

export default function responseStatusReducer(state = { autoSaveResponses: [] }, action) {
    switch (action.type) {
    case responseStatusActions.types.RESPONSE_STATUS_SET_LAST_SAVED:
        return setLastSaved(state, action.contentRevisionId, action.dateStamp);

    case responseStatusActions.types.RESPONSE_STATUS_SET_REPLIED_TO:
        return setRepliedTo(state, action.contentRevisionId, action.repliedTo, action.allDeclarationsRepliedTo);

    case responseStatusActions.types.AUTO_SAVE_FAILED_RESPONSE:
        return setAutoSaveFailedResponse(state, action.contentRevisionId, action.autoSaveResponse);

    default:
        return state;
    }
}
